import WorkflowDetail from "../Pages/WorkflowDetail.vue";
import CollaboratorsManagement from "../Pages/CollaboratorsManagement.vue";
import OrganizationSettings from "../Pages/OrganizationSettings.vue";
import WorkflowList from "../Pages/WorkflowList.vue";
import CourseList from "../Pages/CourseList.vue";
import QuestionTemplateList from "../Pages/QuestionTemplateList.vue";
import OrganizationDirectory from "../Pages/OrganizationDirectory.vue";
import ImportPage from "../Pages/ImportPage.vue";
import DocxTemplate from "../Pages/DocxTemplate.vue";
import ConfirugationPage from "../Pages/ConfigurationPage.vue";
import EditorDetail from "@/modules/Editor/Pages/EditorDetail.vue";
import OfferTemplate from "../Pages/OfferTemplate.vue";
import WorkflowFolder from "../Pages/WorkflowFolder.vue";
import ControlList from "../Pages/ControlList.vue";

export default [
  {
    path: "workflow-folder/:workflowId",
    name: "WORKFLOW_FOLDER",
    component: WorkflowFolder,
    props: true,
    meta: {
      authenticationRequired: true,
      breadcrumbs: [
        {
          name: "WORKFLOW_FOLDER",
          disabled: true,
          label: "utils.workflowSpecific",
        },
      ],
    },
  },
  {
    path: "configuration/",
    name: "CONFIGURATION",
    component: ConfirugationPage,
    props: true,
    meta: {
      authenticationRequired: true,
      rolesRequired: ["ADMINISTRATOR"],
      breadcrumbs: [
        {
          name: "CONFIGURATION",
          disabled: true,
          label: "utils.configuration",
        },
      ],
    },
    children: [
      {
        path: "settings/",
        name: "ORGANIZATION_SETTINGS",
        component: OrganizationSettings,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "ORGANIZATION_SETTINGS",
              disabled: true,
              label: "utils.general",
            },
          ],
        },
      },
      {
        path: "collaborator/",
        name: "COLLABORATORS_MANAGEMENT",
        component: CollaboratorsManagement,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "COLLABORATORS_MANAGEMENT",
              disabled: true,
              label: "utils.collaborators",
            },
          ],
        },
      },
      {
        path: "workflow/",
        name: "WORKFLOW_LIST",
        component: WorkflowList,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "WORKFLOW_LIST",
              disabled: true,
              label: "utils.workflows",
            },
          ],
        },
      },
      {
        path: "workflow/:workflowId",
        name: "workflowDetail",
        component: WorkflowDetail,
        props: true,
        meta: {
          authenticationRequired: true,
          rolesRequired: ["ADMINISTRATOR"],
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "WORKFLOW_LIST",
              disabled: false,
              label: "utils.workflows",
            },
            {
              name: "workflowDetail",
              disabled: true,
              label: "utils.workflowSpecific",
            },
          ],
        },
      },
      {
        path: "course/",
        name: "COURSE_LIST",
        component: CourseList,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "COURSE_LIST",
              disabled: true,
              label: "utils.course",
            },
          ],
        },
      },
      {
        path: "course/:courseId/",
        name: "courseDetail",
        component: EditorDetail,
        props: true,
        meta: {
          authenticationRequired: true,
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "COURSE_LIST",
              disabled: false,
              label: "utils.course",
            },
            {
              name: "courseDetail",
              disabled: true,
              label: "course.management",
            },
          ],
        },
      },
      {
        path: "question-template/",
        name: "QUESTION_TEMPLATE",
        component: QuestionTemplateList,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "QUESTION_TEMPLATE",
              disabled: true,
              label: "utils.question_template",
            },
          ],
        },
      },
      {
        path: "controls/",
        name: "CONTROL_LIST",
        component: ControlList,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "CONTROL_LIST",
              disabled: true,
              label: "Controls",
            },
          ],
        },
      },
      {
        path: "directory/",
        name: "DIRECTORY",
        component: OrganizationDirectory,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "DIRECTORY",
              disabled: true,
              label: "utils.directory",
            },
          ],
        },
      },
      {
        path: "imports/",
        name: "IMPORTS",
        component: ImportPage,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "IMPORTS",
              disabled: true,
              label: "utils.imports",
            },
          ],
        },
      },
      {
        path: "docx-template/",
        name: "DOCX_TEMPLATE",
        component: DocxTemplate,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "DOCX_TEMPLATE",
              disabled: true,
              label: "utils.docx_templates",
            },
          ],
        },
      },
      {
        path: "offer-template/",
        name: "OFFER_TEMPLATE",
        component: OfferTemplate,
        props: true,
        meta: {
          breadcrumbs: [
            {
              name: "CONFIGURATION",
              disabled: false,
              label: "utils.configuration",
            },
            {
              name: "DOCX_TEMPLATE",
              disabled: true,
              label: "utils.offer_templates",
            },
          ],
        },
      },
    ],
  },
];
